import React from 'react';
import { useSelector } from 'react-redux';
import { GridWrapper } from '@yme/atoms/grid';
import { FAQContent } from '@yme/components/FAQContent';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getRTL } from '@yme/selectors/common';
import { FAQContainerStyled } from './styled';
export function FAQ(props) {
    const { sections } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView } = useWindowSize();
    if (!sections?.length) {
        return null;
    }
    return (React.createElement(GridWrapper, { containerProps: {
            smIndentReset: isMobileView,
        } },
        React.createElement(FAQContainerStyled, null,
            React.createElement(FAQContent, { sections: sections, isRightToLeft: isRightToLeft }))));
}
FAQ.displayName = 'FAQ_AEMComponent';
